"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sharing = void 0;
var helpers_1 = require("../helpers/");
var utilities_1 = require("../utilities");
var SHARE_LABELS = {
    facebook: 'Facebook',
    twitter: 'Twitter',
    email: 'Email',
    linkedin: 'LinkedIn',
    pinterest: 'Pinterest',
    link: 'Link',
};
var Sharing = (function () {
    function Sharing(apiSharing, referrers, shareLink) {
        var _this = this;
        this.link = '';
        this.name = apiSharing === null || apiSharing === void 0 ? void 0 : apiSharing.name;
        this.slug = apiSharing === null || apiSharing === void 0 ? void 0 : apiSharing.slug;
        this.targets = (apiSharing === null || apiSharing === void 0 ? void 0 : apiSharing.targets) ? apiSharing.targets : [];
        if (shareLink && helpers_1.isURL(shareLink)) {
            var host = new URL(shareLink).host;
            this.link = (referrers === null || referrers === void 0 ? void 0 : referrers.includes(host)) ? shareLink : '';
        }
        this.sites = __spreadArrays(this.targets.map(function (target) { return ({
            icon: "https://embed.kijk.nl/images/" + target + ".svg",
            label: SHARE_LABELS[target],
            src: function () {
                utilities_1.trackShareLink(target);
                var _a = jwplayer().getPlaylistItem(), title = _a.title, kijkLink = _a.kijkLink;
                var link = _this.link || encodeURIComponent(kijkLink);
                window.open(utilities_1.getTargetUrl(target, link, title));
            },
        }); }), [
            {
                icon: 'https://embed.kijk.nl/images/link.svg',
                label: 'Link',
                src: function () {
                    utilities_1.trackShareLink('link');
                    var kijkLink = jwplayer().getPlaylistItem().kijkLink;
                    var link = _this.link || kijkLink;
                    utilities_1.copyToClipboard(link);
                    utilities_1.addToolTip();
                },
            },
        ]);
    }
    return Sharing;
}());
exports.Sharing = Sharing;
